import { render, staticRenderFns } from "./reissue_apply.vue?vue&type=template&id=1256188c&scoped=true"
import script from "./reissue_apply.vue?vue&type=script&lang=js"
export * from "./reissue_apply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1256188c",
  null
  
)

export default component.exports